import { render, staticRenderFns } from "./ReCardTask.vue?vue&type=template&id=703f1c76"
import script from "./ReCardTask.vue?vue&type=script&lang=js"
export * from "./ReCardTask.vue?vue&type=script&lang=js"
import style0 from "./ReCardTask.vue?vue&type=style&index=0&id=703f1c76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports